module.exports = __webpack_public_path__ + "img/circle.3ebcdd77.svg";